import { PostEngine } from '@nucleus/post';
import { PostSearchController, usePostHubPath } from '@nucleus/post-theme-elements';
import React, { useCallback } from 'react';
import { useSearchParams } from '../hooks/useSearchParams';

export const SearchParam = 'query';

interface SearchUrlControllerProps {
  children: React.ReactNode;
  engineId?: PostEngine['id'];
}
export const PostSearchUrlController = ({ children, ...props }: SearchUrlControllerProps): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams({ include: [SearchParam] });

  const onChange = useCallback((value: string) => {
    setSearchParams.replace({ [SearchParam]: value });
  }, []);

  const value = getSingleValue(searchParams[SearchParam], '');

  return (
    <PostSearchController
      engineId={props?.engineId ?? ''}
      basePath={usePostHubPath(props.engineId)}
      value={value}
      onChange={onChange}
    >
      {children}
    </PostSearchController>
  );
};

const getSingleValue = (value: string | string[] | undefined, fallback: string): string => {
  if (value === undefined) {
    return fallback;
  }

  return Array.isArray(value) ? value[0] ?? fallback : value;
};
